import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import styles from "./createpost.module.css";
import PanoramaIcon from '@material-ui/icons/Panorama';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import CreateIcon from '@material-ui/icons/Create';
import VisibilityIcon from "@material-ui/icons/Visibility";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import PublishIcon from "@material-ui/icons/Publish";
import SettingsIcon from "@material-ui/icons/Settings";
import { Snackbar } from "@material-ui/core";
import { SnackbarContent } from "@material-ui/core";



const InpBody = styled.textarea`
width: 68%;
height: 700px;
margin: 19px auto;
border:0px;
font-size: 25px;
line-height: 55px;
`;
const InpTitle = styled.textarea`
width: 68%;
height: 110px;
margin: 19px auto;
border:0px;
font-size: 35px;
font-weight: 600;
`;
const Container = styled.div`
width: 100%;
display: flex;
flex-direction: column;
`;
const Navbar = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 80%;
margin: 19px auto;
margin-bottom: 30px;
padding: 15px;
border-bottom: 1px solid #dad7d7;
`;
const SubNav = styled.div`
    display: flex;
    width: 30%;
    div {
        margin: 10px;
        cursor: pointer;
    }
`;
const LogoDiv = styled.div`
width: 10%;
img {
    width: 100%;
}
`;

export const CreatePost = () => {
    const [open, setOpen] = useState(false);
    const picRef = useRef();
    const [picDisp, setPicDisp] = useState(false);
    const [inpData, setInpData] = useState({});
    const loggedIn = useSelector(state => state.loggedIn);
    const loggedInUser = useSelector(state => state.loggedInUser);
    const history = useHistory();
    const url = process.env.REACT_APP_url;

    // const handlePublish = () => {
    //     inpData.author = loggedInUser._id;
    //     console.log(inpData);
    //     axios.post("${url}/posts", inpData)
    //         .then((res) => {
    //             console.log(res.data);
    //         })
    //         .catch((err) => {
    //             alert(err);
    //         })
    // }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setInpData({ ...inpData, [name]: value });
    }
    useEffect(() => {
        if (!loggedIn) {
            history.push("/login");
        }
        document.getElementById('output').style.display = "none";
    }, []);
    // const fn = () => {
    //     const file = picRef.current.files[0];
    // }

    var loadFile = function (event) {
        setPicDisp(true);
        var output = document.getElementById('output');
        output.style.display = "block";
        output.src = URL.createObjectURL(event.target.files[0]);
        output.onload = function() {
            URL.revokeObjectURL(output.src);
        }
    };
    const handlePublish = () => {
        console.log(picRef.current.files[0]);
        if (picRef.current.files[0] === undefined) {
            alert("Please select a cover picture for the post.");
        } else {
            let formData = new FormData();
            formData.append('title', inpData.title);
            formData.append('body', inpData.body);
            formData.append('author', loggedInUser._id);
            formData.append('image', picRef.current.files[0]);
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            // console.log(formData, inpData);
            axios.post(`${url}/posts`, formData, config)
                .then(response => {
                    console.log(response.data);
                    setOpen(true);
                    setTimeout(() => {
                        history.push(`/users/${loggedInUser.username}`)
                    }, 2300)
                })
                .catch(error => {
                    alert(error);
                });
        }
    }
    const handleClose = () => {
    setOpen(false);
  };
    return (
        <Container>
            <Navbar>
                <LogoDiv>
                    <img style={{cursor:"pointer"}} onClick={() => history.push("/")} src="https://hash-node.vercel.app/static/media/hashnode.76db81e9.svg" alt="logo"/>
                </LogoDiv>
                <SubNav>
                    {/* <div>Saved</div>
                    <div>Share Draft</div> */}
                    <div style={{display:"flex", alignItems:"center"}} >
                        <SettingsIcon style={{color:"grey"}}/>
                        <div>Settings</div>
                    </div>
                    <div style={{display:"flex", alignItems:"center", border:"1px solid rgb(41,98,255)", borderRadius:"8px", padding:"3px 8px"}} onClick={handlePublish}>
                        <PublishIcon style={{color:"rgb(41,98,255)"}}/>
                        <div style={{color:"rgb(41,98,255)"}}>Publish</div>
                    </div>
                </SubNav>
            </Navbar>
            <div className={styles.addDiv}>
                <label for="ubtn">
                    <PanoramaIcon style={{ color: "#cccacc", marginRight: "10px" }} />
                    <p style={{color: "#cccacc", cursor:"pointer" }}>Add cover photo</p>
                </label>
                <div>
                    <TextFieldsIcon style={{color:"#cccacc", marginRight:"10px"}}/>
                    <div style={{ color: "#cccacc" }}>Add subtitle</div>
                </div>
            </div>
            <div className={styles.uplDiv}>
                <input ref={picRef} id="ubtn" hidden type="file" accept="image/*" onChange={(event)=> loadFile(event)}/>
                <img className={styles.upl} id="output" />
            </div>
            
            
            <InpTitle className={styles.textarea} onChange={handleChange} placeholder="Title" name="title">

            </InpTitle>
            <div className={styles.addons}>
                <div style={{display:"flex", alignItems:"center"}}>
                    <CreateIcon style={{color:"rgb(41,98,255)", marginRight:"6px"}}/>
                    <div style={{color:"rgb(41,98,255)"}}>Write</div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <VisibilityIcon style={{color:"grey", marginRight:"6px"}}/>
                    <div>Preview</div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <PlayCircleOutlineIcon style={{color:"grey", marginRight:"6px"}}/>
                    <div>Guide</div>
                </div>
            </div>
            <InpBody className={styles.textarea} onChange={handleChange} placeholder="Tell your story..." name="body">

            </InpBody>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={open}
                autoHideDuration={2100}
                onClose={handleClose}
            ><SnackbarContent style={{
                    backgroundColor: 'green',
                    width: "290px",
                height: "60px",
                    }}
                    message={<span id="client-snackbar">Blog added successfully!</span>}
                />
                </Snackbar>
        </Container>
    )
}